import { Button } from 'antd';

import { NameWrapper, Wrapper, IconWrapper } from './ActionButton.styles';

import { EIconType, Icon } from '@/components/Icon';

type Props = {
  name: string;
  icon: EIconType;
  onClick?: () => void;
  loading?: boolean;
  danger?: boolean;
  disabled?: boolean;
};

export const ActionButton: React.FC<Props> = ({
  name,
  icon,
  onClick,
  loading = false,
  danger = false,
  disabled = false
}) => {
  return (
    <Wrapper $disabled={disabled} onClick={() => !loading && !disabled && onClick?.()}>
      <IconWrapper $danger={danger} $disabled={disabled} justify="center" align="center">
        <Icon i={icon} color={danger ? 'red6' : 'white'} disabled={disabled} />
      </IconWrapper>
      <Button danger={danger} disabled={disabled} type="text" loading={loading}>
        <NameWrapper>{name}</NameWrapper>
      </Button>
    </Wrapper>
  );
};
